import React from 'react';

export default function ClimbersDealTerms() {
  const styles = {
    page: {
      backgroundColor: '#ffffff',
      minHeight: '100vh',
      fontFamily: 'Times, "Times New Roman", serif',
      color: '#000000',
      margin: 0,
      padding: 0,
    },
    container: {
      maxWidth: '8.5in',
      margin: '0 auto',
      padding: '1in',
      lineHeight: '1.5',
      fontSize: '12pt',
    },
    header: {
      textAlign: 'center',
      marginBottom: '30px',
      borderBottom: '2px solid #000',
      paddingBottom: '20px',
    },
    title: {
      fontSize: '18pt',
      fontWeight: 'bold',
      margin: '0 0 15px 0',
      textTransform: 'uppercase',
      letterSpacing: '1px',
    },
    effectiveDate: {
      fontSize: '12pt',
      fontWeight: 'bold',
      margin: '0 0 10px 0',
    },
    serviceName: {
      fontSize: '12pt',
      fontWeight: 'bold',
      margin: '0 0 15px 0',
    },
    introText: {
      fontSize: '12pt',
      fontStyle: 'italic',
      margin: '0',
      textAlign: 'justify',
    },
    section: {
      marginBottom: '25px',
      pageBreakInside: 'avoid',
    },
    sectionNumber: {
      fontSize: '14pt',
      fontWeight: 'bold',
      marginBottom: '10px',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
    },
    paragraph: {
      fontSize: '12pt',
      marginBottom: '12px',
      textAlign: 'justify',
      textIndent: '0.5in',
      lineHeight: '1.5',
    },
    paragraphNoIndent: {
      fontSize: '12pt',
      marginBottom: '12px',
      textAlign: 'justify',
      lineHeight: '1.5',
    },
    list: {
      paddingLeft: '0.75in',
      marginBottom: '12px',
    },
    listItem: {
      fontSize: '12pt',
      marginBottom: '6px',
      listStyleType: 'disc',
    },
    definitionList: {
      paddingLeft: '0.5in',
      marginBottom: '12px',
    },
    definitionItem: {
      fontSize: '12pt',
      marginBottom: '10px',
      listStyleType: 'none',
    },
    definitionTerm: {
      fontWeight: 'bold',
      display: 'inline',
    },
    footer: {
      marginTop: '40px',
      paddingTop: '20px',
      borderTop: '1px solid #000',
      textAlign: 'center',
      fontSize: '10pt',
      color: '#666',
    },
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>Terms of Service</h1>
          <p style={styles.effectiveDate}>Effective Date: September 10, 2025</p>
          <p style={styles.serviceName}>
            Service Name: Climbers Deal (the "Service," "we," "us," or "our")
          </p>
          <p style={styles.introText}>
            By accessing or using the Service, you agree to be bound by these
            Terms of Service (the "Terms"). If you do not agree to these Terms,
            do not use the Service.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>1. Definitions</h2>
          <ul style={styles.definitionList}>
            <li style={styles.definitionItem}>
              <span style={styles.definitionTerm}>You / User:</span> Any person
              or entity that accesses or uses the Service.
            </li>
            <li style={styles.definitionItem}>
              <span style={styles.definitionTerm}>Content:</span> All
              information displayed or made available by the Service, including
              text, images, links, prices, availability, and other data.
            </li>
            <li style={styles.definitionItem}>
              <span style={styles.definitionTerm}>
                Third Parties / Merchants:
              </span>{' '}
              Websites, stores, platforms, or providers that are not controlled
              by us.
            </li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>2. Eligibility & Compliance</h2>
          <p style={styles.paragraph}>
            You represent and warrant that you: (a) have the legal capacity to
            use the Service; (b) will comply with all applicable laws; and (c)
            will not use the Service in any unlawful or prohibited manner.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>3. Nature of the Service</h2>
          <p style={styles.paragraph}>
            The Service aggregates and surfaces climbing-related deals and
            product information (e.g., shoes) and may link to third-party
            merchants. We do not conduct or guarantee any transaction between
            you and merchants and are not responsible for third-party products,
            services, content, or policies.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>
            4. Information Sources; Accuracy & Updates
          </h2>
          <p style={styles.paragraphNoIndent}>
            <strong>For Reference Only.</strong> Prices, availability, shipping,
            discounts, delivery times, and similar information shown in the
            Service are for reference. The merchant's page prevails.
          </p>
          <p style={styles.paragraphNoIndent}>
            <strong>May Be Delayed or Outdated.</strong> Due to source update
            frequencies, technical factors, or third-party changes, information
            may be non-real-time or out of date.
          </p>
          <p style={styles.paragraphNoIndent}>
            <strong>Commercially Reasonable Efforts.</strong> We use
            commercially reasonable efforts to maintain updates and
            availability, but we do not guarantee accuracy, completeness, or
            timeliness.
          </p>
          <p style={styles.paragraphNoIndent}>
            <strong>Verify Before You Act.</strong> Always verify with the
            merchant before making a purchase or other decision.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>5. Third-Party Links, Services</h2>
          <p style={styles.paragraph}>
            The Service may include links to third-party sites, content, or
            services (including affiliate links from time to time). We do not
            endorse and are not responsible for third-party actions, promises,
            or policies. Your dealings with any third party are solely between
            you and that third party.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>6. Intellectual Property</h2>
          <p style={styles.paragraphNoIndent}>
            Unless stated otherwise, the software, design, trademarks, logos,
            and related content are owned by us or our licensors and are
            protected by intellectual-property laws.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>7. "As Is"; No Warranties</h2>
          <p style={styles.paragraph}>
            The Service and all content are provided "as is" and "as available."
            We make no warranties of any kind, express or implied, including
            accuracy, completeness, timeliness, availability, merchantability,
            fitness for a particular purpose. We do not guarantee that the
            Service will be uninterrupted, error-free, or fully secure; some
            information may be delayed or outdated. You assume all risk for your
            use of the Service.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>8. Maintenance; Changes</h2>
          <p style={styles.paragraph}>
            We may update, modify, suspend, or discontinue any part of the
            Service at any time for technical, operational, or legal reasons. We
            will use commercially reasonable efforts to reduce impact but do not
            guarantee advance notice or uninterrupted availability.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>9. Privacy</h2>
          <p style={styles.paragraph}>
            Please review our Privacy Policy for how we collect, use, and
            protect personal data. Your use of the Service is subject to our
            Privacy Policy.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>10. Changes to These Terms</h2>
          <p style={styles.paragraph}>
            We may update these Terms periodically. Unless stated otherwise,
            updated Terms are effective upon posting within the Service or on
            our official pages. Your continued use indicates acceptance of the
            updates.
          </p>
        </div>

        <div style={styles.footer}>
          <p>Document effective as of September 10, 2025</p>
        </div>
      </div>
    </div>
  );
}
